import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { ConsultaSimpleService } from '../../infrastructure/services/consultaSimple.service';

@Component({
  templateUrl: 'listado.consulta.simple.component.html'
})
export class ListadoConsultaSimpleComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  comandos;

  constructor(private aRoute: ActivatedRoute,
              private router: Router,
              private consultaSimpleService: ConsultaSimpleService,
              private location: Location,
              public loader: LoaderService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];

      this.comandos = this.consultaSimpleService
        .getListadoComandos(this.codSistema, this.codNegocio, this.codProducto);
    });
  }

  navegarANuevaConsultaSimple() {
    this.router.navigate(['./nuevo'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/consultaSimple/listado.consulta.simple.component.ts